<template>
    <div class="flex w-full h-full p-2 contrast-dark-400">
        <div class="flex h-full items-center m-auto text-center" v-for="(quiz, index) in logged_user.quizzes">
            <router-link tag="div" :to="'quiz/'+quiz.id" class="w-40">
                <img :src="getIcon(quiz.name)" :alt="quiz.name" class="h-40 w-40 mb-4 rounded-xl">
                {{quiz.name}}
            </router-link>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'home',
    data() {
      return {

      }
    },
    computed: {
        ...mapGetters('profile',['logged_user']),

    },

    methods: {

    },
    mounted() {

    }
  }
</script>
